import React from 'react';
import { GlassPage } from '../components/chrome';

const SECTIONS = [
  {
    title: '1. Information We Collect',
    body: 'We collect information you provide directly to us, such as your name and email address when you contact us, apply for a position, or order a product. We also collect basic usage data to understand how visitors use our website.'
  },
  {
    title: '2. How We Use Your Information',
    body: 'We use the information we collect to respond to your inquiries, process reservations, communicate product updates, and improve our website and services. We do not sell your personal information to third parties.'
  },
  {
    title: '3. Data Security',
    body: 'We take reasonable measures to protect your personal information from unauthorized access, loss, or misuse. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.'
  },
  {
    title: '4. Your Rights',
    body: 'You may request access to, correction of, or deletion of the personal information we hold about you at any time. To exercise these rights, contact us using the information below.'
  },
  {
    title: '5. Changes to This Policy',
    body: 'We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated revision date. Continued use of our services after changes constitutes acceptance of the revised policy.'
  }
];

const PrivacyPolicy = () => {
  return (
    <GlassPage>
      {/* Hero Section */}
      <section className="relative flex flex-col justify-center px-6 md:px-12 pt-40 pb-12">
        <div className="max-w-4xl mx-auto w-full">
          <h1 className="text-[12vw] md:text-[6vw] font-bold leading-[0.9] tracking-tighter mb-8 uppercase text-zinc-900">
            Privacy<br/>Policy
          </h1>
          <p className="text-sm text-zinc-400">
            Last Updated: June 2026
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-8 md:py-12 px-4 md:px-6">
        <div className="glass max-w-4xl mx-auto px-8 md:px-12 py-12 md:py-16 space-y-12">
          {SECTIONS.map((section) => (
            <div key={section.title} className="space-y-4">
              <h2 className="text-2xl md:text-3xl font-bold tracking-tighter uppercase text-zinc-900">
                {section.title}
              </h2>
              <p className="text-zinc-500 leading-relaxed">{section.body}</p>
            </div>
          ))}

          <div className="space-y-4">
            <h2 className="text-2xl md:text-3xl font-bold tracking-tighter uppercase text-zinc-900">
              6. Contact Us
            </h2>
            <p className="text-zinc-500 leading-relaxed">
              If you have any questions about this Privacy Policy, please contact us at:
            </p>
            <p className="text-zinc-900 font-bold">contact@korsa.tech</p>
          </div>
        </div>
      </section>
    </GlassPage>
  );
};

export default PrivacyPolicy;
